import script from "./GameView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameView.vue?vue&type=script&setup=true&lang=ts"

import "./GameView.vue?vue&type=style&index=0&id=a2bda3b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2bda3b4"]])

export default __exports__